"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearcherFormMobileLayout = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = require("react-responsive-modal");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _rebrand = require("../../icons-react/rebrand");
var _Button = _interopRequireDefault(require("../Button"));
var _userAgentUtils = require("../../utils/userAgentUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SearcherFormMobileLayout = exports.SearcherFormMobileLayout = /*#__PURE__*/_react["default"].memo(function (props) {
  var open = props.open,
    children = props.children,
    popupLabel = props.popupLabel,
    onSubmit = props.onSubmit,
    submitButtonText = props.submitButtonText,
    containerStyles = props.containerStyles,
    container = props.container,
    _props$onCancel = props.onCancel,
    onCancel = _props$onCancel === void 0 ? function () {
      return {};
    } : _props$onCancel,
    withHeader = props.withHeader,
    _props$isWhiteLabel = props.isWhiteLabel,
    isWhiteLabel = _props$isWhiteLabel === void 0 ? false : _props$isWhiteLabel,
    isSearcher = props.isSearcher;
  var hasSubmitButton = Boolean(submitButtonText);

  // Используются inline стили, так как react-responsive-modal не может в Styled components:
  var Styles = _objectSpread({
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    width: '100vw',
    height: '100%',
    margin: 0,
    padding: 0,
    zIndex: 12000
  }, withHeader ? {
    background: ' #f5f4f2'
  } : {});
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal.Modal, (0, _extends2["default"])({}, props, {
    container: container || undefined,
    styles: {
      modal: Styles,
      overlay: {
        padding: 0,
        background: '#FFFF00',
        zIndex: 12000,
        pointerEvents: 'auto'
      }
    },
    open: open,
    onClose: onCancel,
    showCloseIcon: false,
    blockScroll: !_userAgentUtils.iOSSafari
  }), withHeader ? /*#__PURE__*/_react["default"].createElement(StyledHeader, {
    $isWhiteLabel: isWhiteLabel
  }, /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, {
    onClick: onCancel
  })) : /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, popupLabel), /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    onClick: onCancel,
    type: "button"
  }, t('touristsPicker.button.cancel'))), /*#__PURE__*/_react["default"].createElement(StyledBody, null, /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    hasSubmitButton: hasSubmitButton,
    containerStyles: containerStyles,
    withHeader: withHeader
  }, children), submitButtonText ? /*#__PURE__*/_react["default"].createElement(StyledButtonContainer, null, /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    onClick: onSubmit,
    withHeader: withHeader,
    $isSearcher: isSearcher
  }, submitButtonText)) : null));
});
SearcherFormMobileLayout.displayName = 'SearcherFormMobileLayout';
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledWrapper",
  componentId: "sc-ffhmrx-0"
})(["position:relative;text-align:center;font-size:16px;display:flex;align-items:flex-end;justify-content:flex-end;margin-block-start:0;margin-block-end:0;padding:14px 8px;"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "SearcherFormMobileLayout__StyledLabel",
  componentId: "sc-ffhmrx-1"
})(["position:absolute;transform:translate(-50%,0);left:50%;"]);
var StyledCancelButton = _styledComponents["default"].button.withConfig({
  displayName: "SearcherFormMobileLayout__StyledCancelButton",
  componentId: "sc-ffhmrx-2"
})(["line-height:16px;font-size:14px;border:none;background:transparent;color:var(--secondary);cursor:pointer;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledContainer",
  componentId: "sc-ffhmrx-3"
})(["max-height:calc( 100% - ", "px );overflow-y:auto;", ";", ""], function (_ref) {
  var hasSubmitButton = _ref.hasSubmitButton;
  return hasSubmitButton ? 95 : 45;
}, function (_ref2) {
  var containerStyles = _ref2.containerStyles;
  return containerStyles;
}, function (_ref3) {
  var withHeader = _ref3.withHeader;
  return withHeader && "margin-top: 8px;";
});
var StyledButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledButtonContainer",
  componentId: "sc-ffhmrx-4"
})(["margin-top:auto;margin-bottom:8px;padding:0 8px;width:100%;"]);
var StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SearcherFormMobileLayout__StyledSubmitButton",
  componentId: "sc-ffhmrx-5"
})(["--background-color:", ";font-size:16px;line-height:20px;background-color:var(--background-color);width:100%;color:", ";border-radius:var(--border-radius);", ""], function (_ref4) {
  var $isSearcher = _ref4.$isSearcher;
  return $isSearcher ? "var(--secondary)" : "var(--secondary-header)";
}, function (_ref5) {
  var $isSearcher = _ref5.$isSearcher;
  return $isSearcher ? "var(--secondary-color)" : "var(--secondary-header-color)";
}, function (_ref6) {
  var withHeader = _ref6.withHeader;
  return withHeader && (0, _styledComponents.css)(["color:var(--white) !important;&:hover{background:linear-gradient( 0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100% ),var(--background-color);}"]);
});
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledHeader",
  componentId: "sc-ffhmrx-6"
})(["min-height:64px;background-color:var(--primary-header);display:flex;justify-content:flex-end;"]);
var StyledCloseIcon = (0, _styledComponents["default"])(_rebrand.XMark).withConfig({
  displayName: "SearcherFormMobileLayout__StyledCloseIcon",
  componentId: "sc-ffhmrx-7"
})(["height:24px;margin-top:20px;margin-right:16px;"]);
var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormMobileLayout__StyledBody",
  componentId: "sc-ffhmrx-8"
})(["background:#fff;height:100%;display:flex;flex-direction:column;"]);